import React from 'react';
import cn from 'classnames';

var styles = {"loader":"button__loader_n1hu2","blink":"button__blink_n1hu2"};
 require('./buttonloader.css')

function ButtonLoader(_a) {
    var className = _a.className;
    return (React.createElement("div", { className: cn(styles.loader, className) },
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null)));
}

export { ButtonLoader as default };
